import React from 'react';

interface modalButtonProps {
  label?: string;
  onClick?: () => void;
  textColor?: string;
  bgColor?: string;
  borderColor?: string;
  hoverBorderColor?: string;
  width?: string;
  shadow?: string;
  icon?: React.ReactNode;
  disable?: boolean;
}

const ModalButton: React.FC<modalButtonProps> = ( {
  label,
  onClick,
  shadow = 'shadow-md',
  textColor = 'text-red-base',
  bgColor = 'bg-white',
  borderColor = 'border-white-base',
  hoverBorderColor = 'hover:border-red-base',
  width = 'w-fit',
  icon,
  disable = false,
} ) => {

  return (
    <button
      className={`group border-[2.5px] ${borderColor} ${width} rounded-2xl p-1 trans-fast
        ${disable ? 'cursor-not-allowed' : `${hoverBorderColor} cursor-pointer`}
      `}
      onClick={disable ? undefined : onClick}
    >
      <div
        className={`
          trans-fast px-4 py-2 h-full rounded-xl flex items-center gap-2
          ${disable ? 'text-gray-500 bg-gray-300 shadow-none' : `${bgColor} ${textColor} ${shadow}`}
        `}
      >
        {icon && <span>{icon}</span>}
        <span className='whitespace-nowrap'>{label}</span>
      </div>
    </button>
  );
};

export default ModalButton;
